import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (19 / 24);
  const localHeight = size * (19 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 19 19">
      <path
        d="M0,9.5A9.5,9.5,0,1,1,9.5,19,9.511,9.511,0,0,1,0,9.5Zm1.462,0A8.038,8.038,0,1,0,9.5,1.462,8.047,8.047,0,0,0,1.462,9.5Zm3.437.731a.731.731,0,1,1,0-1.461h9.2a.731.731,0,1,1,0,1.461Z"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
